import * as React from 'react';

export interface AnalyticsLayoutProps {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;

  /** A css class to be applied to the component's root element */
  className?: string;

  /** Items that will be rendered  */
  items: React.ReactNode[];

  /** Children  */
  children: AnalyticsLayoutChildren;
}

type AnalyticsLayoutChildren = (
  item: React.ReactNode,
  index: number,
  rowItemsCount: number,
) => React.ReactNode;

export interface AnalyticsLayoutCellProps {
  dataHook?: string;
  disableHighlight?: boolean;
  children: React.ReactNode;
}
